import { useTranslation } from 'react-i18next';
import apiDefinitions from '../loyalty-performance-api-defintitions';
import APIDefinitions from 'components/api-definitions/api-definitions.component';

type MembershipDefinitionsTypes = {
  isOffer?: boolean;
};

const MembershipDefinitions = ({ isOffer }: MembershipDefinitionsTypes) => {
  const { t } = useTranslation();
  const membershipDefinitions = [
    !!isOffer
      ? apiDefinitions.newMembersOffer
      : apiDefinitions.newMembersLocation,
    !isOffer && apiDefinitions.membersWhoOrdered,
    apiDefinitions.deletedAccounts,
    apiDefinitions.activeMembers,
    !isOffer && apiDefinitions.activeMemberPercent,
  ].filter(Boolean);

  return (
    <APIDefinitions
      definitions={membershipDefinitions}
      type={t(
        'page.loyaltyPerformanceReport.apiDefinitionTitles.membership.label',
      )}
    />
  );
};

export default MembershipDefinitions;
